// extracted by mini-css-extract-plugin
module.exports = {"normalPrice":"UnitPrice_normalPrice__KC0ES","subscriptionPrice":"UnitPrice_subscriptionPrice____eZj","meal":"UnitPrice_meal__Iv_yR"};